module.exports = __webpack_public_path__ + "static/media/strawberry-jam.1dfde050.jpg";